<script setup lang="ts">
import { computed, defineProps } from "vue";
import { Site } from "@/types/v2";
import { useSitesStore } from "@/stores/v2";
import SitesListItem from "./SitesListItem.vue";

interface SitesListProps {
  sites: Site[]
}

defineProps<SitesListProps>()

const sites = computed(() => useSitesStore().getSites)

const handleSelect = (siteKey: string) => {
  useSitesStore().setActiveSite(siteKey)
}
</script>

<template>
  <p v-if="sites.length === 0" class="text-gray-500 text-center py-8">
    No sites found...
  </p>

  <ul>
    <SitesListItem @click="handleSelect(site.key)" v-for="site in sites" :key="site.key" :text="site.name"
      :siteKey="site.key" />
  </ul>
</template>